export default {
  WIDGET_EVENT_IDLE_USER: 'WIDGET_EVENT_IDLE_USER',
  WIDGET_EVENT_CHAT_END: 'WIDGET_EVENT_CHAT_END',
  WIDGET_EVENT_PERSISTENT_SURVEY: 'WIDGET_EVENT_PERSISTENT_SURVEY',
  AGENTDESK_FEEDBACK_REVIEW: 'AGENTDESK_FEEDBACK_REVIEW',
  SURVEY: 'REJECTED',
  SUBMITTED: 'SUBMITTED',
  NEGATIVE_MAP_KEY: 'negativeSuggestionMap',
  POSITIVE_MAP_KEY: 'positiveSuggestionMap',
  NEGATIVE: 'NEGATIVE',
  POSITIVE: 'POSITIVE',
  SURVEY_FORM: 'SurveyForm',
  SKIP_EVENT: 'event://;SKIP_EVENT;',
  DISABLE_RESUME_WORKFLOW: 'resumeWorkflow::value=false',
  ENABLE_RESUME_WORKFLOW: 'resumeWorkflow::value=true',
  CLOSE: 'CLOSE',
  SKIP: 'SKIP',
  GOOD: 'Good',
  BAD: 'Bad',
  YES: 'Yes',
  NO: 'No',
  SURVEY_DOT: 'SURVEY.',
  DOT: '.',
  BASIC_INFO: 'BASIC_INFO',
  POSITIVE_FEEDBACK_HEADER: 'POSITIVE_FEEDBACK.HEADER',
  NEGATIVE_FEEDBACK_HEADER: 'NEGATIVE_FEEDBACK.HEADER',
  POSITIVE_CHOICES_CHOICE_: 'POSITIVE_FEEDBACK.Choices.CHOICE_',
  NEGATIVE_CHOICES_CHOICE_: 'NEGATIVE_FEEDBACK.Choices.CHOICE_',
  ISSUE_RESOLUTION_FEEDBACK: 'ISSUE_RESOLUTION_FEEDBACK',
  BUTTON_YES: 'BUTTON_YES',
  BUTTON_NO: 'BUTTON_NO',
  BUTTON_ADD: 'BUTTON_ADD',
  ADD: '+',
  ADDITIONAL_FEEDBACK: 'ADDITIONAL_FEEDBACK',
  ADDITIONAL_FEEDBACK_TEXT: 'ADDITIONAL_FEEDBACK_TEXT',
  ADDITIONAL_FEEDBACK_CONTEXT: 'Add additional feedback',
  SUBMIT: 'SUBMIT',
  START_TYPING: 'START_TYPING',
  THANK_YOU: 'Thank You!',
  FOR_YOUR_FEEDBACK: 'for your feedback',
  OVERALL_RATING: 'Over all how would you rate?',
  VIEW_RESPONSE: 'VIEW_RESPONSE',
}
